// File: app/src/apis/llm/index.js
//
// Public entry for the LLM API. Assembles the same default-exported object the
// monolithic llmApi.js exposed (issue #16 refactor), so every existing import
// of `apis/llmApi` keeps working unchanged.

import { generateWorkoutPlan } from "./generateWorkoutPlan";
import {
  repairSession,
  parseLoggedWorkout,
  enhanceExercise,
  generateExerciseSubstitutions,
  reviewProgrammePlan,
  readProgrammeText,
} from "./operations";
import { buildPrompt, generateDynamicExample } from "./prompts";
import { extractJSON } from "./extract";

const llmApi = {
  generateWorkoutPlan,
  repairSession,
  parseLoggedWorkout,
  enhanceExercise,
  generateExerciseSubstitutions,
  reviewProgrammePlan,
  readProgrammeText,
  // Export utilities for testing
  _utils: {
    buildPrompt,
    extractJSON,
    generateDynamicExample,
  },
};

export default llmApi;
